module.exports = __webpack_public_path__ + "img/base_activites_rando_equestre.5e3a6bee.svg";